import { createContext, useState } from "react";

const AnimationContext = createContext({});

export const AnimationProvider = ({ children }) => {
  const [showedAnimation, setShowedAnimation] = useState(false);

  return (
    <AnimationContext.Provider value={{ showedAnimation, setShowedAnimation }}>
      {children}
    </AnimationContext.Provider>
  );
};

export default AnimationContext;
